import { render, staticRenderFns } from "./send-import-dialog.vue?vue&type=template&id=4ebfadb4&"
import script from "./send-import-dialog.vue?vue&type=script&lang=js&"
export * from "./send-import-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports